module.exports = __webpack_public_path__ + "static/logo-white-f455a8172c8a79dfd6eadc243e508412.svg";